import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ContainerWithoutInner } from '@/components/foundations/content';
import { StaticImage } from 'gatsby-plugin-image';
import Button from '@/components/objects/button';
import Attention from '@/components/projects/attention';
import * as styles from './keyVisual.module.scss';
import * as containerStyles from '@/components/foundations/content/content.module.scss';
import * as Buttonstyles from '@/components/objects/button/button.module.scss';
import LogoSvg from '@/svgs/common/logo';

const KeyVisualContent: React.FC<{ modal: Function; isScrolled: boolean }> = ({ modal, isScrolled }) => {
  const [pleaseScroll, setPleaseScroll] = useState(false);
  const [vh, setVh] = useState(0);

  const innnerStyle = classNames(containerStyles.lContent__inner, styles.lContent__inner);
  const outerStyle = classNames(styles.oKeyVisual__outer, {
    [styles.pleaseScroll]: pleaseScroll && isScrolled,
  });
  const computedInnerStyle = {
    height: vh < 1 ? '100vh' : `${vh}px`,
  };

  useEffect(() => {
    setVh(window.innerHeight);
    setTimeout(() => {
      if (!isScrolled) setPleaseScroll(true);
    }, 6000);
  }, []);

  return (
    <div className={outerStyle}>
      <div className={innnerStyle} style={computedInnerStyle}>
        <div className={styles.oKeyVisual__message}>
          <span>プロトタイプご担当者の方へ</span>
          <p>最小コストでプロダクトを成功させる</p>
          <h1 hidden>PIVOTのプロトタイピング</h1>
          <h2>
            <LogoSvg />
            <strong>プロトタイピング</strong>
          </h2>
          <p>
            “うまくいくかわからない…”
            <br />
            そのモヤモヤ、今すぐ解決しませんか？
          </p>
          <Attention>
            <a href="https://pivot.jp/contact">
              <Button
                className={`${styles.oButton, Buttonstyles.conversion}`}
              >
                相談してみる
              </Button>
            </a>
          </Attention>
        </div>
      </div>
      <figure className={styles.oKeyVisual__image}>
        <StaticImage src="./img/kv.png" alt="最小コストでプロダクトを成功させる Pivotのプロトタイピング" />
      </figure>
    </div>
  );
};

const KeyVisual: React.FC<{ modal: Function; isScrolled: boolean }> = ({ modal, isScrolled }) => {
  return (
    <ContainerWithoutInner className={{ wrapper: styles.oKeyVisual }} intersection={{ visible: styles.visible }}>
      <KeyVisualContent modal={modal} isScrolled={isScrolled} />
    </ContainerWithoutInner>
  );
};

export default KeyVisual;
